import React, { Component, Fragment } from 'react';
import { canUseDOM } from 'exenv';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';
import { imageSizesLookup } from '../../../utils/cloudinary_asset_util';
import formatPostObject from '../../../utils/format_post_object';
import Ad from '../ad/ad';
import Card from '../card/card';
import Scroll from '../scroll/scroll';
import Social from '../social/social';
// import NewsletterSignup from '../newsletters/newsletter-signup';
import { trackGAEvent } from '../../../client/utils/third_party_trackers/ga';
import asyncPostNativeAdActions from '../../../redux/actions/post/async_post_native_ad_actions';
import adLoaded from '../../../redux/action_creators/ads_action_creator';
import ClientSideWrapper from '../client_side_wrapper/client_side_wrapper';
import PianoInline from '../piano/pianoInline';

class FeatureFeed extends Component {
  constructor(props) {
    super(props);
    this.getFeaturedStory = this.getFeaturedStory.bind(this);
    this.buildActiveSponsoredCardDataObject = this.buildActiveSponsoredCardDataObject.bind(
      this
    );
    this.getFeaturedStory = this.getFeaturedStory.bind(this);
    this.getSponsoredCardDataFromNativePixel = this.getSponsoredCardDataFromNativePixel.bind(
      this
    );
    this.getScrollingModule = this.getScrollingModule.bind(this);
    this.renderSponsoredCard = this.renderSponsoredCard.bind(this);
    this.renderPromoCard = this.renderPromoCard.bind(this);
    this.state = {
      sponsoredCardData: null
    };
  }

  componentWillReceiveProps(nextProps) {
    const nativeAdHomepageTileLoaded = get(
      nextProps,
      'adsLoaded.native_homepagefeature'
    );

    if (nativeAdHomepageTileLoaded) {
      this.getSponsoredCardDataFromNativePixel();
      this.props.dispatchAdLoadedEvent('native_homepagefeature', false);
    }

    const newPostNativeAd = get(
      nextProps,
      'postNativeAd.homepageFeaturedTile.posts'
    );

    if (
      get(newPostNativeAd, 'length') !==
        get(this.props, 'postNativeAd.homepageFeaturedTile.posts.length') &&
      get(newPostNativeAd, 'length')
    ) {
      this.setState({
        sponsoredCardData: newPostNativeAd
      });
    }
  }

  getFeaturedStory(post) {
    return formatPostObject({
      props: this.props,
      post,
      imgSize: imageSizesLookup[1],
      allowTextOnly: true
    });
  }

  getSponsoredCardDataFromNativePixel() {
    const initialPageLoad = get(this.props, 'config.initialPageLoad');

    if (!initialPageLoad && canUseDOM) {
      const nativeAdsData = get(window, 'fc_ads.native.homepageFeaturedTile');
      // console.log('nativeAdsData', nativeAdsData);
      if (!nativeAdsData) {
        return;
      }

      // Check if it's native_type === homepageFeaturedTile
      if (get(nativeAdsData, 'native_type') === 'homepageFeaturedTile') {
        if (
          !get(nativeAdsData, 'article_ids') &&
          !get(nativeAdsData, 'campaign_name') &&
          !get(nativeAdsData, 'clickthrough_url')
        ) {
          return;
        }

        this.props.dispatchPostNativeAd(
          nativeAdsData,
          get(this.props, 'config')
        );
      }
    }
  }

  getScrollingModule(scrollingModule) {
    const scrollingModuleTag = get(scrollingModule, 'tag', null);
    const newsStories = get(scrollingModule, 'posts', []).map(post =>
      formatPostObject({
        props: this.props,
        post,
        imgSize: imageSizesLookup.column,
        allowNoImage: true,
        deck: false
      })
    );
    const newsFeed = get(newsStories, 'length')
      ? { stories: newsStories, tag: scrollingModuleTag }
      : { stories: [], tag: scrollingModuleTag };

    return newsFeed;
  }

  buildActiveSponsoredCardDataObject() {
    // console.log('build sponsor card');
    const featuredSponsoredCardType = get(
      this.state.sponsoredCardData,
      '[0].cardType'
    );

    if (!featuredSponsoredCardType) {
      // console.log('no sponsored card found');
      return [
        {
          newsletter: true,
          poster:
            'https://assets.fastcompany.com/image/upload/c_scale,w_289/v1605552418/co-design-logo-neg-2020_2x.png',
          title: 'Innovation in your inbox.',
          deck: 'Sign up for the daily newsletter.',
          noLazy: true
        }
      ];
    }

    // const parsedCardMetadata = JSON.parse(cardMetadata);
    const featuredSponsoredCardData = {
      Event() {
        const nativeAdsData = get(window, 'fc_ads.native.homepageFeaturedTile');

        return [
          {
            id: '12345',
            topic: 'Events',
            title: get(nativeAdsData, 'caption_text'),
            link: get(nativeAdsData, 'clickthrough_url'),
            featured_image: {
              source: get(nativeAdsData, 'poster')
            },
            external: true,
            currentSite: get(this.props, 'config.site'),
            events: true,
            customEyebrowText: get(nativeAdsData, 'sponsor'),
            buttonText: get(nativeAdsData, 'button_text'),
            assetSizes: imageSizesLookup.bigFirstMobile,
            noLazy: true
          }
        ];
      },
      'Sponsored Story': () => this.state.sponsoredCardData
    };
    // figure out which card type it is, and send relevant metadata
    return featuredSponsoredCardData[featuredSponsoredCardType]();
  }

  renderSponsoredCard() {
    // console.log('render sponsored card');
    const initialPageLoad = get(this.props, 'config.initialPageLoad');

    if (!initialPageLoad && canUseDOM) {
      // console.log('should build sponsor card');
      const item = this.buildActiveSponsoredCardDataObject()[0];

      if (!get(item, 'newsletter')) {
        return (
          <Fragment>
            <Card
              metadata={item}
              noBottomBorder={false}
              config={get(this.props, 'config')}
              cardEvent={() => {
                trackGAEvent({
                  eventCategory: 'Engagement',
                  eventAction: 'FeaturedFeed:Pos-4:sponsored',
                  eventLabel: get(item, 'link')
                });
              }}
            />
          </Fragment>
        );
      }

      return (
        <div className="card card--default" style={{ display: 'none' }}>
          <Fragment>
            <PianoInline />
          </Fragment>
        </div>
      );
    }

    // server render nothing
    return '';
  }

  renderPromoCard(arrayLength) {
    if (arrayLength === 0 || !arrayLength) {
      return false;
    }
    return (
      <Fragment>
        {this.props.promoterChannelFcWorks.map((obj, index) => (
          <Card
            key={index}
            type="promo"
            config={get(this.props, 'config')}
            metadata={obj}
            last={index === arrayLength}
            supertags={this.props.supertags}
          />
        ))}
      </Fragment>
    );
  }

  render() {
    const {
      featuredFeed,
      scrollingModule,
      social,
      config,
      combinedAdModel,
      shouldRenderDesktop,
      adPostion,
      promoterChannelFcWorks,
      loading
    } = this.props;

    const featured = get(featuredFeed, 'featured', []);
    const topStories = get(featuredFeed, 'top', []);
    const totalTopStories = get(topStories, 'length');
    const totalPromoterStories = get(promoterChannelFcWorks, 'length', 0);
    const hasSocial = !isEmpty(social) && 'row--social';
    const showOnlyDesktop = shouldRenderDesktop;
    const showOnlyMobile = !shouldRenderDesktop;

    return (
      <section className={`featured-feed featured-feed--${this.props.page} `}>
        <div className={`row ${hasSocial}`}>
          {hasSocial ? <Social {...social} /> : ''}
          <div className="featured-feed__stories">
            {featured.map((feature, index) => {
              const featuredStory = this.getFeaturedStory(feature);
              return (
                <Card
                  key={`feature-${index}`}
                  type="featured"
                  metadata={featuredStory}
                  config={config}
                  cardEvent={() => {
                    trackGAEvent({
                      eventCategory: 'Engagement',
                      eventAction: `FeaturedFeed:Pos-${index + 1}`,
                      eventLabel: get(featuredStory, 'link')
                    });
                  }}
                  loading={loading}
                />
              );
            })}
          </div>
          <Scroll
            config={config}
            metadata={this.getScrollingModule(scrollingModule)}
            promoBanner={this.props.promoBanner}
            className="news-column"
            bottomAd={featured.length > 1}
            combinedAdModel={combinedAdModel}
            shouldRenderDesktop={shouldRenderDesktop}
          />
        </div>

        {get(this.props, 'featuredFeed.featured').length ? (
          <div className={`${this.props.page}-page__ff-ad-container`}>
            <ClientSideWrapper
              showOnlyDesktop={showOnlyDesktop}
              showOnlyMobile={showOnlyMobile}
            >
              <Ad
                {...combinedAdModel}
                noLazyLoad
                pos="atf"
                name={`flexiblebillboard_${adPostion}`}
              />
              <Ad
                {...combinedAdModel}
                noLazyLoad
                pos="atf"
                name={`mobileparallax_${adPostion}`}
              />
            </ClientSideWrapper>
          </div>
        ) : (
          ''
        )}

        {totalTopStories >= 2 ? (
          <div>
            <ClientSideWrapper
              showOnlyDesktop={showOnlyDesktop}
              showOnlyMobile={showOnlyMobile}
            >
              <Ad
                {...combinedAdModel}
                pos="atf"
                noBorder={true}
                slug={false}
                name="native_homepagefeature"
              />
            </ClientSideWrapper>
          </div>
        ) : (
          ''
        )}

        {totalTopStories >= 2 ? (
          <div className="row">
            {topStories.slice(0, 2).map((post, i, arr) => (
              <Card
                key={post.id}
                metadata={formatPostObject({
                  props: this.props,
                  post,
                  imgSize: imageSizesLookup[arr.length + 1],
                  allowTextOnly: true
                })}
                config={config}
                totalCards={arr.length + 1}
                cardEvent={() => {
                  trackGAEvent({
                    eventCategory: 'Engagement',
                    eventAction: `FeaturedFeed:Pos-${i + 2}`,
                    eventLabel: get(post, 'link')
                  });
                }}
              />
            ))}
            {this.renderSponsoredCard()}
          </div>
        ) : null}

        {totalPromoterStories ? (
          <div className="promo-container">
            <div className="promo-container--image-container">
              {' '}
              <img
                className="promo-container--partnership"
                src="https://assets.fastcompany.com/image/upload/v1619192201/fc_works_promo.png"
                alt=""
              />{' '}
            </div>
            <div className="channel-fc-works-promo">
              {' '}
              {this.renderPromoCard(totalPromoterStories)}{' '}
            </div>
          </div>
        ) : null}

        {totalTopStories >= 4 ? (
          <div className="row">
            {topStories.slice(2, 4).map((post, i, arr) => (
              <Card
                key={post.id}
                metadata={formatPostObject({
                  props: this.props,
                  post,
                  imgSize: imageSizesLookup[arr.length],
                  allowTextOnly: true
                })}
                config={config}
                align="center"
                totalCards={arr.length}
                cardEvent={() => {
                  trackGAEvent({
                    eventCategory: 'Engagement',
                    eventAction: `FeaturedFeed:Pos-${i + 5}`,
                    eventLabel: get(post, 'link')
                  });
                }}
              />
            ))}
          </div>
        ) : null}
      </section>
    );
  }
}

function mapStateToProps(state = {}) {
  return {
    config: state.config,
    postpage: state.postpage,
    postNativeAd: get(state, 'postNativeAd.data', {}),
    adsLoaded: get(state, 'ads.data'),
    supertags: get(state, 'supertags.supertags', {})
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchPostNativeAd(nativeAdsData, config) {
      return asyncPostNativeAdActions(dispatch, config, nativeAdsData);
    },

    dispatchAdLoadedEvent(adName, status) {
      dispatch(adLoaded(adName, status));
    }
  };
}

FeatureFeed.defaultProps = {
  isPromoting: false,
  social: {},
  promoBanner: {},
  postNativeAd: {},
  shouldRenderDesktop: false,
  adPostion: 1,
  promoterChannelFcWorks: [],
  loading: '',
  supertags: {}
};

FeatureFeed.propTypes = {
  config: PropTypes.shape({}).isRequired,
  featuredFeed: PropTypes.shape({
    source: PropTypes.string,
    featured: PropTypes.arrayOf(PropTypes.shape({})),
    top: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  dispatchAdLoadedEvent: PropTypes.func.isRequired,
  scrollingModule: PropTypes.shape({}).isRequired,
  promoterChannelFcWorks: PropTypes.arrayOf(PropTypes.shape({})),
  combinedAdModel: PropTypes.shape({}).isRequired,
  dispatchPostNativeAd: PropTypes.func.isRequired,
  page: PropTypes.string.isRequired,
  postNativeAd: PropTypes.shape({}),
  promoBanner: PropTypes.shape({}),
  isPromoting: PropTypes.bool,
  social: PropTypes.shape({}),
  shouldRenderDesktop: PropTypes.bool,
  adPostion: PropTypes.number,
  loading: PropTypes.string,
  supertags: PropTypes.shape({})
};

export default connect(mapStateToProps, mapDispatchToProps)(FeatureFeed);
